import { Command, Node, mergeAttributes } from '@tiptap/core';

export interface WritingLineOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    writingLine: {
      /**
       * Add a writing line
       */
      setWritingLine: () => ReturnType;
      /**
       * Add a writing line and keep focus
       */
      addWritingLine: () => ReturnType;
    };
  }
}

export const WritingLine = Node.create<WritingLineOptions>({
  name: 'writingLine',

  addOptions() {
    return {
      HTMLAttributes: {
        class: 'writing-line',
      },
    };
  },

  group: 'block',

  parseHTML() {
    return [{ tag: 'hr.writing-line' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['hr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },

  addCommands() {
    return {
      setWritingLine:
        (): Command =>
        ({ chain }) => {
          return chain().insertContent({ type: this.name }).run();
        },
      addWritingLine:
        (): Command =>
        ({ state, dispatch }) => {
          const { $from } = state.selection;
          const pos = $from.end();

          if (dispatch) {
            const tr = state.tr.insert(pos, this.type.create());
            dispatch(tr);
          }

          return true;
        },
    };
  },
});

export default WritingLine;
